module.exports = __webpack_public_path__ + "img/collaboration.1e5e01ad.svg";